"use strict";

exports.__esModule = true;
exports.MetricValueWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _MetricValueElement = require("./MetricValueElement");
var _MetricValueFields = require("./MetricValueFields");
var _MetricValueHeader = require("./MetricValueHeader");
var _MetricValueThumbnail = require("./MetricValueThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MetricValueWidget = exports.MetricValueWidget = {
  name: "MetricValue",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "MetricValueWidget.label",
    defaultMessage: "Metric Value"
  }),
  icon: "trending-up",
  group: _widgetGroups.METRIC_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "MetricValue",
      props: Object.assign({
        width: 256,
        height: 64,
        metricName: "utilization",
        showTarget: false,
        hideLabel: false
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: ["device"],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color", "backgroundColor", "backgroundColorSource", "dataRange"],
  requiresProps: ["x", "y", "width", "height", "metricName"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 1024
    },
    height: {
      "default": 64,
      min: 32,
      max: 768
    }
  },
  components: {
    Header: _MetricValueHeader.MetricValueHeader,
    Element: _MetricValueElement.MetricValueElement,
    Fields: _MetricValueFields.MetricValueFields,
    Thumbnail: _MetricValueThumbnail.MetricValueThumbnail
  }
};